var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 9 16 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.374 9.79c-2.387-1.793-5.938-.376-6.375 2.665-.436-3.04-3.986-4.458-6.375-2.666-1.884 1.414-2.442 4.403.031 6.66 2.266 2.066 4.603 2.664 6.344 5.203 1.742-2.539 4.08-3.137 6.345-5.204 2.474-2.256 1.915-5.245.03-6.659"
})));
export default SvgHeart;